import React from "react";
import { ClipLoader } from "react-spinners";

interface Props {
    hasBg: boolean
}

const Loader = ({ hasBg }: Props) => {
    return (
        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', width: '100%', height: '100%', position: 'fixed', top: 0, left: 0, zIndex: 1234567, background: hasBg ? 'rgba(0, 0, 0, 0.20)' : undefined }}>
            <ClipLoader
                color={'#4d83d1'}
                loading={true}
                size={70}
                speedMultiplier={1}
            />
        </div>
    )
}

Loader.defaultProps = {
    hasBg: true
}

export default Loader;